import React, { useEffect, useState } from 'react';
import { AlertProps, Alert as MuiAlert, Snackbar } from "@mui/material";
import { useApp } from '../../Contexts/AppProvider';

interface IPropsRef extends HTMLDivElement {}

interface IProps extends AlertProps {}

const AlertContent = React.forwardRef<IPropsRef, IProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Alert () {
  const { alertValues, onAlert } = useApp();
  const [visible, setVisible] = useState(false);

  const handleClose = (_?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setVisible(false);
    alertValues?.onClose && alertValues?.onClose();
    setTimeout(() => onAlert(null), 500);
  };

  useEffect(() => {
    alertValues?.message && setVisible(true)
  }, [alertValues?.message])

  return (
    <Snackbar
      open={visible}
      autoHideDuration={alertValues?.autoHideDuration || 6000}
      anchorOrigin={{vertical: 'top', horizontal: 'right'}}
      onClose={handleClose}>
      <AlertContent
      onClose={handleClose}
      severity={alertValues?.severity}
      sx={{ width: '100%' }}>
        {alertValues?.message}
      </AlertContent>
    </Snackbar>
  )
} 